import { render } from "./ForgottenPassword.vue?vue&type=template&id=06f60ee5&scoped=true"
import script from "./ForgottenPassword.vue?vue&type=script&lang=js"
export * from "./ForgottenPassword.vue?vue&type=script&lang=js"

import "./ForgottenPassword.vue?vue&type=style&index=0&id=06f60ee5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-06f60ee5"

export default script